module.exports = __webpack_public_path__ + "static/fonts/Oxanium-ExtraLight.ab227bf1.ttf";